import React, { Component } from 'react';
import './DialogButton.css';
export default class DialogButton extends Component{
	constructor(props){
		super(props);
			const {onClick, text, className}=props;
			this._className = className;
			this._text = text;
			this._onClick = onClick;
	}
	render(){
		let className = "dialog-button";
		if(this._className)className+=` ${this._className}`;
		return (
			<button className={className} onClick={this._onClick}>{this._text}
			</button>);
	}
}